

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { store } from "store/store"; 

import App from "App";
import { MaterialUIControllerProvider } from "context";
import { AuthProvider } from "AuthProvider";
import { ToastProvider } from "ToastMassage/ToastMessage";
import ToastMessageRedux from "ToastMassage/ToastMessageRedux";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
<BrowserRouter basename="/">
<AuthProvider>
    <MaterialUIControllerProvider>
    <Provider store={store}>
    <ToastMessageRedux /> 
      <App />
   </Provider>
    </MaterialUIControllerProvider>
    </AuthProvider>
</BrowserRouter>
);
